module.exports = __webpack_public_path__ + "static/media/19ESCAP52.5cf3ed40.jpg";